module.exports = __webpack_public_path__ + "img/footprint.b5152511.png";